"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserAuctionPropertyDto = instanceOfUserAuctionPropertyDto;
exports.UserAuctionPropertyDtoFromJSON = UserAuctionPropertyDtoFromJSON;
exports.UserAuctionPropertyDtoFromJSONTyped = UserAuctionPropertyDtoFromJSONTyped;
exports.UserAuctionPropertyDtoToJSON = UserAuctionPropertyDtoToJSON;
exports.UserAuctionPropertyDtoToJSONTyped = UserAuctionPropertyDtoToJSONTyped;
/**
 * Check if a given object implements the UserAuctionPropertyDto interface.
 */
function instanceOfUserAuctionPropertyDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('slug' in value) || value['slug'] === undefined)
        return false;
    return true;
}
function UserAuctionPropertyDtoFromJSON(json) {
    return UserAuctionPropertyDtoFromJSONTyped(json, false);
}
function UserAuctionPropertyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'slug': json['slug'],
        'displayAddress': json['displayAddress'] == null ? undefined : json['displayAddress'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}
function UserAuctionPropertyDtoToJSON(json) {
    return UserAuctionPropertyDtoToJSONTyped(json, false);
}
function UserAuctionPropertyDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'slug': value['slug'],
        'displayAddress': value['displayAddress'],
        'imageUrl': value['imageUrl'],
    };
}
